/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('getSchemaButton', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./get-schema-button.html'),

      replace: true,

      link(scope, element, attrs) {},
    };
  },
]);
